var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.AuthLayout,
    {
      scopedSlots: _vm._u([
        {
          key: "pitch",
          fn: function () {
            return [
              _c(_setup.StoreDescription, {
                attrs: { "store-type": _setup.storeType },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(_setup.AuthCardHeader, { attrs: { title: _setup.cardTitle } }),
      _vm._v(" "),
      _setup.step == "choice"
        ? [
            _setup.checkoutCancelled
              ? _c(_setup.CAlert, {
                  attrs: {
                    text:
                      "Your account is saved, but the payment is what finishes the sign up. Log in with the same account whenever you are ready to complete the checkout.",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.SocialAuthButton, {
              attrs: {
                label: "Sign up with your email",
                disabled: !!_setup.loadingProvider,
              },
              on: {
                click: function ($event) {
                  _setup.step = "form"
                },
              },
            }),
            _vm._v(" "),
            _setup.provider
              ? [
                  _c(_setup.OrDivider),
                  _vm._v(" "),
                  _c(_setup.SocialAuthButton, {
                    attrs: {
                      provider: _setup.provider,
                      label: `Sign up with ${_setup.providerLabel}`,
                      loading: !!_setup.loadingProvider,
                    },
                    on: {
                      click: function ($event) {
                        return _setup.signUpWith(_setup.provider)
                      },
                    },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _setup.error
              ? _c(_setup.CError, { attrs: { message: _setup.error } })
              : _vm._e(),
          ]
        : _setup.step === "form"
        ? _c(_setup.SignUpForm, {
            key: _setup.prefilled?.pendingTicket || "manual",
            attrs: {
              "store-type": _setup.storeType,
              "lock-store-type": _setup.isManagedByChipAdmin,
              "managed-by": _setup.managedBy,
              prefilled: _setup.prefilled,
            },
            on: {
              back: _setup.onFormBack,
              "update:storeType": function ($event) {
                _setup.storeType = $event
              },
              registered: _setup.onManualRegistered,
              completed: _setup.onSignUpCompleted,
            },
          })
        : _setup.step === "email"
        ? _c(_setup.EmailStep, {
            attrs: { "pending-ticket": _setup.pendingTicket },
            on: {
              back: _setup.onFormBack,
              completed: _setup.onSignUpCompleted,
            },
          })
        : _setup.step === "verify"
        ? _c("div", { staticClass: "verify-message" }, [
            _c("p", { staticClass: "m-0" }, [
              _vm._v(
                "\n            Your account is almost ready. Finish the checkout and confirm your email address with the link we just\n            sent you.\n        "
              ),
            ]),
            _vm._v(" "),
            _setup.error
              ? _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c(_setup.CError, { attrs: { message: _setup.error } }),
                    _vm._v(" "),
                    _setup.registeredAccount
                      ? _c(_setup.CButton, {
                          staticClass: "w-100",
                          attrs: {
                            variant: "primary",
                            text: "Try again",
                            disabled: _setup.openingCheckout,
                          },
                          on: { click: _setup.openCheckout },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "signin-link" }, [
        _vm._v("Already have an account? "),
        _c("a", { attrs: { href: "/signin" } }, [_vm._v("Log in")]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }